import { track } from '@vercel/analytics/react';

import { logger } from '../logger';

/**
 * Event types for analytics tracking
 */
export type EventCategory =
  | 'button'
  | 'link'
  | 'form'
  | 'navigation'
  | 'interaction';

/**
 * Structure of a tracking event
 */
export interface TrackingEvent {
  category: EventCategory;
  action: string;
  label?: string;
  value?: number;
  properties?: Record<string, unknown>;
}

/**
 * Tracks an event using Vercel Analytics
 */
export const trackEvent = (event: TrackingEvent): void => {
  if (typeof window !== 'undefined' && 'va' in window) {
    // Vercel Analytics
    track(event.action, {
      category: event.category,
      label: event.label ?? '',
      value: event.value ?? '',
      ...event.properties,
    });

    // Log in development
    if (process.env.NODE_ENV === 'development') {
      logger.debug('Analytics event:', { event });
    }
  } else if (process.env.NODE_ENV === 'development') {
    // Log in development when analytics is not available
    logger.debug('Analytics event (no Vercel Analytics):', { event });
  }
};

/**
 * Convenience function for tracking button clicks
 */
export const trackButtonClick = (
  buttonName: string,
  properties?: Record<string, unknown>,
): void => {
  trackEvent({
    category: 'button',
    action: 'click',
    label: buttonName,
    properties,
  });
};
